import { createMotionComponentWithFeatures } from "./utils.mjs";
import { domMax } from "../../features/dom-max.mjs";
const motion = createMotionComponentWithFeatures(domMax);
const Motion = motion.create("div");
export {
  Motion,
  motion
};
